// src/services/api.ts (or wherever you keep API calls)
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export async function registerAffiliate(data: {
  name: string;
  email: string;
  phone: string;
}) {
  const response = await fetch(`${API_URL}/api/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Registration failed');
  }

  return await response.json();
}